import { render } from "./LinkCTAButtons.vue?vue&type=template&id=38468daa&scoped=true"
import script from "./LinkCTAButtons.vue?vue&type=script&lang=ts"
export * from "./LinkCTAButtons.vue?vue&type=script&lang=ts"

import "./LinkCTAButtons.vue?vue&type=style&index=0&id=38468daa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-38468daa"

export default script